import React from "react"
import { Grid } from "@mui/material"

import { makeStyles } from "makeStyles"

import MobileViewItem from "components/Algolia/Results/MobileViewItem"
import LockingSystemMobileViewItem from "./LockingSystem/LockingSystemMobileViewItem"

import { AlgoliaLockingSystemHit, AlgoliaProductHit } from "@secureo/common/typings/Algolia"
import { AlgoliaUIPageType } from "../AlgoliaSearchUI"

const useStyles = makeStyles()({
	ul: {
		display: "flex",
		flexWrap: "wrap",
		listStyle: "none",
		paddingLeft: 0,
	},
	li: {
		width: "50%",
		transition: "0.3s",
	},
})

const MobileListView = ({ hits, locale, categoryName, pageType }: Props) => {
	const { classes } = useStyles()

	if (hits.length === 0) return null

	const isLockingSystem = pageType === "locking-systems"

	return (
		<>
			<Grid container spacing={0}>
				<ul className={classes.ul}>
					{hits.map((hit, position) => {
						return (
							<li className={classes.li} key={hit.objectID}>
								{isLockingSystem ? (
									<LockingSystemMobileViewItem
										hit={hit as AlgoliaLockingSystemHit}
										locale={locale}
										position={position + 1}
										categoryName={categoryName}
									/>
								) : (
									<MobileViewItem
										hit={hit as AlgoliaProductHit}
										locale={locale}
										position={position + 1}
										categoryName={categoryName}
									/>
								)}
							</li>
						)
					})}
				</ul>
			</Grid>
		</>
	)
}

interface Props {
	hits: (AlgoliaProductHit | AlgoliaLockingSystemHit)[]
	locale: string
	categoryName: string
	pageType?: AlgoliaUIPageType
}

export default MobileListView
